export interface TranslationFormData {
  urls: string;
  targetLang: string;
}

export type TargetLanguage =
  | 'esCO'
  | 'esAR'
  | 'esCL'
  | 'esPE'
  | 'esMX'
  | 'esCAC';

export interface LanguageOption {
  value: TargetLanguage;
  label: string;
}

export const TARGET_LANGUAGES: LanguageOption[] = [
  { value: 'esCO', label: 'Español Colombia (esCO)' },
  { value: 'esAR', label: 'Español Argentina (esAR)' },
  { value: 'esCL', label: 'Español Chile (esCL)' },
  { value: 'esPE', label: 'Español Perú (esPE)' },
  { value: 'esMX', label: 'Español México (esMX)' },
  { value: 'esCAC', label: 'Español Centroamérica (esCAC)' },
];

export interface TranslationRulesSummary {
  summary: string;
  targetLanguage: string;
}
